/* eslint-disable react/no-array-index-key */

import TableRow from './TableRow';
import type { DataItems, GetCellTextProps, KeyDetails } from './tableTypes';
/*
  See Table component
*/
export default function TableBody({
  data,
  getCellTextProps,
  keyDetails,
}: {
  data: DataItems;
  getCellTextProps?: GetCellTextProps;
  keyDetails: KeyDetails;
}) {
  return (
    <>
      {data.map((rowData, index) => (
        <TableRow
          data={rowData}
          getCellTextProps={getCellTextProps}
          key={index}
          keyDetails={keyDetails}
        />
      ))}
    </>
  );
}
